export default "__VITE_ASSET__B00feEp7__"